import apiClient from './apiClient';

/**
 * Legal documents. The same endpoints serve signed-in and signed-out readers:
 * without a token only the documents that must be public are returned, and
 * apiClient adds the bearer token automatically when one exists, which unlocks
 * the restricted documents. So no separate "public" client is needed.
 */
const legalService = {
  /** @returns {Promise<Array>} catalogue entries the caller may read */
  listDocuments: async () => {
    const response = await apiClient.get('/legal/documents');
    return response.data.data.documents;
  },

  /** @returns {Promise<object>} the full document, both languages */
  getDocument: async (slug) => {
    const response = await apiClient.get(`/legal/documents/${encodeURIComponent(slug)}`);
    return response.data.data;
  },
};

export default legalService;
